export default {
  'light': {
    label: 'Light',
    class: "roast-light",
  },
  'medium': {
    label: 'Medium',
    class: "roast-medium",
  },
  'medium-dark': {
    label: 'Med/Dark',
    class: "roast-medium-dark",
  },
  'dark': {
    label: 'Dark',
    class: "roast-dark",
  },
};
